import { Link } from 'react-router-dom';
import { Mail, ChevronRight } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary text-white">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* About */}
          <div className="lg:col-span-1">
            <h2 className="font-playfair text-2xl font-bold text-white mb-5">
              Inside<span className="text-[hsl(var(--gold))]">Higher</span>Education
            </h2>
            <p className="text-white/70 text-sm leading-relaxed mb-5">
              Your trusted source for higher education news, university rankings, online courses, and career development resources.
            </p>
            <div className="flex flex-col gap-2 text-sm">
              <div className="flex items-center gap-2 text-white/70">
                <Mail size={16} className="text-[hsl(var(--gold))] flex-shrink-0" />
                <a href="mailto:contact@insidehighereducation.eu" className="hover:text-[hsl(var(--gold))] transition-colors">
                  contact@insidehighereducation.eu
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-5 pb-2 border-b border-white/10">
              Quick Links
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/universities', label: 'Universities' },
                { to: '/courses', label: 'Online Courses' },
                { to: '/scholarships', label: 'Scholarships' },
                { to: '/rankings', label: 'Rankings' },
                { to: '/blog', label: 'Deals for Students' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-white/70 hover:text-[hsl(var(--gold))] transition-colors text-sm flex items-center gap-1 group"
                    data-testid={`footer-${link.to.slice(1)}`}
                  >
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-5 pb-2 border-b border-white/10">
              Resources
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/study-usa', label: 'Study in USA' },
                { to: '/study-europe', label: 'Study in Europe' },
                { to: '/skills', label: 'Skills & Certifications' },
                { to: '/submit-guest-post', label: 'Submit Guest Post' },
                { to: '/advertise', label: 'Advertise With Us' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-white/70 hover:text-[hsl(var(--gold))] transition-colors text-sm flex items-center gap-1 group"
                    data-testid={`footer-${link.to.slice(1)}`}
                  >
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-playfair text-lg font-bold text-white mb-5 pb-2 border-b border-white/10">
              Company
            </h3>
            <ul className="space-y-3">
              {[
                { to: '/about', label: 'About Us' },
                { to: '/contact', label: 'Contact' },
                { to: '/privacy', label: 'Privacy Policy' },
                { to: '/terms', label: 'Terms & Conditions' },
                { to: '/affiliate-disclosure', label: 'Affiliate Disclosure' },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-white/70 hover:text-[hsl(var(--gold))] transition-colors text-sm flex items-center gap-1 group"
                    data-testid={`footer-${link.to.slice(1)}`}
                  >
                    <ChevronRight size={14} className="opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/60 text-sm">
              &copy; {currentYear} InsideHigherEducation. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
